module.exports = __webpack_public_path__ + "static/media/chat-speech-balloon.ded28369.svg";